import { createContext } from 'react'

import { createPriceIndexChartStore } from '../store/createStore'

export const PriceIndexChartContext = createContext<
  ReturnType<typeof createPriceIndexChartStore> | undefined
>(undefined)
